/**
 * Activewear silhouettes: sports_bra, tracksuit.
 *
 * active_tee and cycling_shorts live in tops.ts and bottoms.ts respectively.
 */
import { OUTLINE_ATTRS, DETAIL_ATTRS, DETAIL_FILLED_ATTRS, STITCH_ATTRS } from "./_attrs.js";
import { ribBand, sideStripe, elasticGather, neckLabel } from "./_primitives.js";

import type { FlatView } from "../flat-svg.js";

/* ── Sports bra (wide straps, racerback, cropped) ─────────────────── */
export function sports_braFlat(view: FlatView): string {
  return `<g>
  ${
    view === "front"
      ? `<path ${OUTLINE_ATTRS} d="M 162 86 L 142 92 Q 124 110 132 136 L 132 260 Q 200 272 268 260 L 268 136 Q 276 110 258 92 L 238 86 Q 200 76 162 86 Z"/>
  <path ${DETAIL_ATTRS} d="M 162 86 Q 200 108 238 86"/>
  <path ${STITCH_ATTRS} d="M 165 91 Q 200 112 235 91"/>
  <path ${DETAIL_ATTRS} d="M 200 108 L 200 254"/>
  <path ${STITCH_ATTRS} d="M 196 110 L 196 250"/>
  <path ${STITCH_ATTRS} d="M 204 110 L 204 250"/>
  <path ${STITCH_ATTRS} d="M 134 250 Q 200 262 266 250"/>`
      : `<path ${OUTLINE_ATTRS} d="M 162 86 L 142 92 Q 118 106 132 136 L 132 260 Q 200 272 268 260 L 268 136 Q 282 106 258 92 L 238 86 Q 200 76 162 86 Z"/>
  <path ${DETAIL_ATTRS} d="M 162 86 Q 186 92 200 108 Q 214 92 238 86"/>
  <path ${STITCH_ATTRS} d="M 165 91 Q 188 96 200 112 Q 212 96 235 91"/>
  <path ${STITCH_ATTRS} d="M 134 250 Q 200 262 266 250"/>
  ${neckLabel(200, 90)}`
  }
</g>`;
}

/* ── Tracksuit (jacket + trouser side-by-side at ~47% scale) ──────── */
export function tracksuitFlat(view: FlatView): string {
  // Left side: zip-front jacket (~47% scale in x: 20–194, y: 30–260)
  // Right side: track pants (~47% scale in x: 206–380, y: 30–470)
  return `<g>
  <path ${OUTLINE_ATTRS} d="M 56 56 L 30 64 L 14 124 L 6 172 L 32 178 L 40 148 L 48 112 L 48 232 L 162 232 L 162 112 L 170 148 L 178 178 L 204 172 L 196 124 L 180 64 L 154 56 Q 105 46 56 56 Z"/>
  ${ribBand(52, 56, 154, 6)}
  ${ribBand(232, 48, 162, 8)}
  <path ${DETAIL_FILLED_ATTRS} d="M 6 172 L 32 178 L 30 188 L 4 182 Z"/>
  <path ${DETAIL_FILLED_ATTRS} d="M 204 172 L 178 178 L 180 188 L 206 182 Z"/>
  ${
    view === "front"
      ? `<path ${DETAIL_ATTRS} d="M 105 58 L 105 230"/>
  <path ${STITCH_ATTRS} d="M 102 62 L 102 228"/>
  <path ${STITCH_ATTRS} d="M 108 62 L 108 228"/>
  <rect x="100" y="70" width="10" height="12" rx="1.5" ${DETAIL_FILLED_ATTRS}/>`
      : `<path ${DETAIL_ATTRS} d="M 56 56 Q 105 50 154 56"/>
  <path ${STITCH_ATTRS} d="M 52 86 L 158 86"/>
  ${neckLabel(105, 56, 16, 10)}`
  }
  <path ${OUTLINE_ATTRS} d="M 238 56 L 352 56 L 356 76 L 362 260 Q 348 270 330 270 L 322 146 Q 316 136 310 146 L 302 270 Q 284 270 270 260 L 276 76 Z"/>
  <path ${DETAIL_ATTRS} d="M 276 76 L 356 76"/>
  ${elasticGather(64, 244, 346)}
  <path ${STITCH_ATTRS} d="M 278 72 L 354 72"/>
  ${sideStripe(280, 350, 76, 264)}
  ${
    view === "front"
      ? `<path ${DETAIL_ATTRS} d="M 316 76 L 316 134"/>
  <path ${STITCH_ATTRS} d="M 313 78 Q 310 106 312 136"/>`
      : `<path ${DETAIL_ATTRS} d="M 280 104 Q 316 114 352 104"/>
  <path ${STITCH_ATTRS} d="M 282 108 Q 316 118 350 108"/>`
  }
  ${elasticGather(264, 272, 300)}
  ${elasticGather(264, 332, 360)}
</g>`;
}
